// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"rw_a bik_a bik_r bik_sb bik_ry bik_rz","GroupsGrid__row__item":"rw_b bik_be bik_rz"};